// Starter templates for different request types
import { DocumentTemplate, createTemplateItem } from '../models/templateModels';
import starterTemplatesData from './starterTemplatesData.json';

export type RequestType = 'loan' | 'employment' | 'rental' | 'insurance' | 'healthcare' | 'custom';

export interface StarterTemplate {
  id: string;
  type: RequestType;
  name: string;
  description: string;
  icon: string;
  category: string;
  template: Omit<DocumentTemplate, 'id' | 'createdAt' | 'updatedAt' | 'createdBy'>;
}

// Load starter templates from JSON file and add generated IDs to items
export const starterTemplates: StarterTemplate[] = starterTemplatesData.map(template => {
  const templateItem = createTemplateItem(true);
  return {
    ...template,
    template: {
      ...template.template,
      items: template.template.items.map(item => ({
        id: templateItem.id + Math.random().toString(36).substr(2, 9), // Generate unique ID
        nameKey: item.nameKey,
        customName: item.customName,
        descriptionKey: item.descriptionKey,
        customDescription: item.customDescription,
        isRequired: item.isRequired,
        order: item.order,
        templateFile: null
      }))
    }
  } as StarterTemplate;
});

// Get templates by category
export const getTemplatesByCategory = (): Record<string, StarterTemplate[]> => {
  return starterTemplates.reduce((acc, template) => {
    if (!acc[template.category]) {
      acc[template.category] = [];
    }
    acc[template.category].push(template);
    return acc;
  }, {} as Record<string, StarterTemplate[]>);
};

// Get template by ID
export const getStarterTemplateById = (id: string): StarterTemplate | undefined => {
  return starterTemplates.find(t => t.id === id);
};
